import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'

import { Icons } from 'msp-components'
import translations from './PaymentMethodDisplay.constants'
import { PaymentMethodTypeBankAccountProps } from './PaymentMethodDisplay.types'
import * as S from './PaymentMethodDisplay.styles'

const PaymentMethodTypeBankAccount = ({
  className = '',
  paymentInstrument
}: PaymentMethodTypeBankAccountProps) => {
  const { formatMessage } = useIntl()
  const { paymentBankAccount, bankRoutingNumber } = paymentInstrument
  const customerData = paymentInstrument.c_billingAddress
    ? JSON.parse(paymentInstrument.c_billingAddress)
    : null
  const {
    salutation,
    firstName,
    lastName,
    postalCode,
    city,
    address1,
    address2
  } = customerData || {}
  return (
    <div className={twMerge(S.PaymentMethodDisplayWrapper, className)}>
      <div className={S.PaymentMethodDisplayIconWrapper}>
        <Icons iconName='Debit' size='3xl' />
      </div>
      <div className={S.PaymentMethodDisplayContentWrapper}>
        <div className={S.PaymentMethodDisplayNameWrapper}>
          {formatMessage(translations.UNZER_DIRECT_DEBIT_SECURED)}
        </div>
        {customerData && (
          <>
            {paymentBankAccount && (
              <div className={S.PaymentMethodDisplayStandardWrapper}>
                {formatMessage(translations.iban, {
                  number: paymentBankAccount.maskedNumber.replace(/\s/g, ''),
                  holder: paymentBankAccount.holder,
                  br: <br />
                })}
              </div>
            )}
            {paymentInstrument.c_maskedNumber && (
              <div className={S.PaymentMethodDisplayStandardWrapper}>
                {formatMessage(translations.iban, {
                  number: paymentInstrument.c_maskedNumber,
                  holder: paymentInstrument.c_holder,
                  br: <br />
                })}
              </div>
            )}
            <div className={S.PaymentMethodDisplayStandardWrapper}>
              {`${salutation || ''} ${firstName || ''} ${lastName || ''}`}
            </div>
            <div className={S.PaymentMethodDisplayStandardWrapper}>
              {`${address1 || ''} ${address2 || ''}`}
            </div>
            <div className={S.PaymentMethodDisplayStandardWrapper}>
              {`${city || ''} ${postalCode || ''}`}
            </div>
            {bankRoutingNumber && (
              <div className={S.PaymentMethodDisplayStandardWrapper}>
                {formatMessage(translations.bankRoutingNumber, {
                  number: paymentInstrument.bankRoutingNumber
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentMethodTypeBankAccount
